import React, { useState, useRef, useEffect } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateTestimonialTabData,testimonialTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [activeLayoutCustomiseWidthSection, setActiveLayoutCustomiseWidthSection] = useState(false);
    const [widthLayoutCustomise, setLayoutCustomiseWidth] = useState(testimonialTabData.layout_custom_width);
    const [selectedLayoutTabRows, setSelectedLayoutTabRows] = useState(testimonialTabData.layout_items_per_page);
    const [showLayoutTabRowsDropdown, setShowLayoutTabRowsDropdown] = useState(false);
    const [selectedLayoutTabMobileRows, setSelectedLayoutTabMobileRows] = useState(testimonialTabData.layout_items_per_page_on_mobile);
    const [showLayoutTabMobileRowsDropdown, setShowLayoutTabMobileRowsDropdown] = useState(false);
    const [selectedLayoutTabSpacing, setSelectedLayoutTabSpacing] = useState(testimonialTabData.layout_item_spacing);
    const [showLayoutLoadMore, setShowLayoutLoadMore] = useState(Number(testimonialTabData.layout_is_show_load_more_button));
    const [showLayoutTabSpacingDropdown, setShowLayoutTabSpacingDropdown] = useState(false);
    const layoutTabSpacingValues = [0, 2, 10, 20, 30, 40, 50];
    const layoutTabWidthToggleRef = useRef(null);
    const [isLayoutTabWidthToggleEnabled, setIsLayoutTabWidthToggleHeaderEnabled] = useState(false);
    const [isWidgetTitle, setIsWidgetTitle] = useState(Number(testimonialTabData.layout_is_widget_title));
    const [widgetTitleName, setWidgetTitleName] = useState(testimonialTabData.layout_widget_title_name);
    const [widgetCaptionName, setWidgetCaptionName] = useState(testimonialTabData.layout_widget_caption_name);

    const toggleLayoutTabRowsDropdown = () => {
        setShowLayoutTabRowsDropdown(!showLayoutTabRowsDropdown);
    };
    const toggleLayoutTabMobileRowsDropdown = () => {
        setShowLayoutTabMobileRowsDropdown(!showLayoutTabMobileRowsDropdown);
    };
    const handleLayoutTabRowSelect = (row) => {
        setSelectedLayoutTabRows(row);
        setShowLayoutTabRowsDropdown(false);
        updateTestimonialTabData("layout_items_per_page", row); 
    };
    const handleLayoutTabMobileRowSelect = (row) => {
        setSelectedLayoutTabMobileRows(row);
        setShowLayoutTabMobileRowsDropdown(false);
        updateTestimonialTabData("layout_items_per_page_on_mobile", row); 
    };
    const toggleLayoutTabSpacingDropdown = () => {
        setShowLayoutTabSpacingDropdown(!showLayoutTabSpacingDropdown);
    };
    const handleLayoutTabSpacingSelect = (spacing) => {
        setSelectedLayoutTabSpacing(spacing);
        updateTestimonialTabData("layout_item_spacing", spacing); 
        setShowLayoutTabSpacingDropdown(false); 
    };

    // Handlers Is Show Load More Button Change
    const handlIsShowLoadMoreChange = (e) => {
        const checked = e.target.checked;
        setShowLayoutLoadMore(checked);
        updateTestimonialTabData("layout_is_show_load_more_button", checked); 
    };

    const showLayoutWidthSection = () => {
        setActiveLayoutCustomiseWidthSection(true);
    };

    const hideLayoutWidthSection = () => {
        setActiveLayoutCustomiseWidthSection(false);
    };

    const handleWidthChange = (e) => {
        const newWidth = parseInt(e.target.value, 10);
        setLayoutCustomiseWidth(newWidth);
        updateTestimonialTabData('layout_custom_width', newWidth);
    };

    useEffect(() => {
        const checkbox = layoutTabWidthToggleRef.current;
        if (checkbox) {
            setIsLayoutTabWidthToggleHeaderEnabled(checkbox.checked);
        }
    }, []);

    const handleLayoutTabWidthToggle = () => {
        const checkbox = layoutTabWidthToggleRef.current;
        if (checkbox) {
            const isChecked = checkbox.checked;
            setIsLayoutTabWidthToggleHeaderEnabled(isChecked);
            if (isChecked) {
                // Full width enabled
                updateTestimonialTabData('layout_is_full_width', isChecked);
                updateTestimonialTabData('layout_custom_width', widthLayoutCustomise);
            } else {
                // Custom width enabled, apply custom width value
                updateTestimonialTabData('layout_custom_width', 1280);
            }
        }
    };

    // Handlers Is Widget Title  Change
    const handlIsWidgetTitleChange = (e) => {
        const checked = e.target.checked;
        setIsWidgetTitle(checked);
        updateTestimonialTabData("layout_is_widget_title", checked); 
    };

    // Handlers Widget Title Change
    const handlWidgetTitleNameChange = (e) => {
        const value = e.target.value;
        setWidgetTitleName(value);
        updateTestimonialTabData("layout_widget_title_name", value); 
    };

    // Handlers Widget Caption Name Change
    const handlWidgetCaptionNameChange = (e) => {
        const value = e.target.value;
        setWidgetCaptionName(value);
        updateTestimonialTabData("layout_widget_caption_name", value); 
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Layout</span>
                    <div className="layout-box-all">
                        <div className="card h-100">
                            <div className="label-box-flex">
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="carousel_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'carousel_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head"> 
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/carosusel.svg`} alt="icon-25" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/carosusel.svg`} alt="carosusel" className="blue-image" /> 
                                        </div>
                                        <div className="content_sub">Carousel</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="grid_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'grid_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head"> 
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/grid.svg`} alt="grid" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/grid.svg`} alt="grid" className="blue-image" /> 
                                        </div>
                                        <div className="content_sub">Grid</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="list_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'list_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head"> 
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/list.svg`} alt="list" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/list.svg`} alt="list" className="blue-image" />
                                        </div>
                                        <div className="content_sub">List</div>
                                    </div>
                                </label>
                           
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="masonry_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'masonry_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head"> 
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/masonry.svg`} alt="masonry" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/masonry.svg`} alt="masonry" className="blue-image" />
                                        </div>
                                        <div className="content_sub">Masonry</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="badge_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'badge_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/badge.svg`} alt="badge" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/badge.svg`} alt="badge" className="blue-image" />
                                        </div>
                                        <div className="content_sub">Badge</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="floating_badge_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'floating_badge_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head"> 
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/floatingbadge.svg`} alt="floatingbadge" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/floatingbadge.svg`} alt="floatingbadge" className="blue-image" />
                                         </div>
                                        <div className="content_sub">Floating Badge</div>
                                    </div>
                                </label>
                           
                                <label className="card-radio-btn">
                                    <input type="radio" name="layout_tab_type" value="slider_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'slider_layout'} />
                                    <div className="card card-body">
                                        <div className="content_head"> 
                                            <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/white/slider.svg`} alt="slider" className="gry-image" /> <img src={`${process.env.PUBLIC_URL}/testimonials/layout-icons/blue/slider.svg`} alt="slider" className="blue-image" />
                                        </div>
                                        <div className="content_sub">Slider</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div className="customize-button">
                            <button onClick={() => setActiveSettingElementsTab("slider_layout")}>Customize</button>
                        </div>
                    </div>
                    <div className="customize-width">
                        <div className="onclick-custom-width" onClick={showLayoutWidthSection}><span>Width</span> 
                            {isLayoutTabWidthToggleEnabled ? (
                                <><em>{widthLayoutCustomise === 'auto' ? 'Auto' : `${widthLayoutCustomise}px`}</em></>
                            ) : (
                                <><em>Width</em></> 
                            )}
                        </div>
                        <div className={`width-custom-box ${activeLayoutCustomiseWidthSection ? 'width-custom-box-open' : ''}`}>
                            <div className="width-custom-inner">
                                <ul>
                                    <li><h6>Width</h6> <button className="done-width" onClick={hideLayoutWidthSection}>Done</button></li>
                                    <li><span>Full Width</span>
                                        <div className="form-group">
                                            <input type="checkbox" id="layout_full_width_toggle" className="chkbx-toggle" ref={layoutTabWidthToggleRef} onChange={handleLayoutTabWidthToggle} defaultChecked={true}/>
                                            <label for="layout_full_width_toggle"></label>
                                        </div>
                                    </li>
                                    {isLayoutTabWidthToggleEnabled && (
                                    <>
                                    <li>
                                        <span>Custom Width</span> <em>{widthLayoutCustomise === 'auto' ? 'Auto' : `${widthLayoutCustomise}px`}</em>
                                        <div className="slider-container">
                                            <input type="range" min="200" max="1920" value={widthLayoutCustomise} onChange={handleWidthChange} />
                                            <div className="value"><span id="slider-value">200</span>px</div>
                                            <div className="widht-1920">1920px</div>
                                        </div>
                                    </li>
                                    </>
                                    )}
                                </ul>
                                <i className="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("widget_title")}>Widget Title <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "slider_layout" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Slider Layout</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Columns</span>
                                <em>{ testimonialTabData.layout_columns }</em>
                            </div>
                            <div className="box-header-row">
                                <span>Rows</span>
                                <div className="dropdown-container">
                                    <em onClick={toggleLayoutTabRowsDropdown}>{selectedLayoutTabRows}</em>
                                    {showLayoutTabRowsDropdown && (
                                        <ul className="dropdown-list">
                                            {[...Array(8).keys()].map((i) => {
                                                const rowValue = i + 1; 
                                                return (
                                                    <li key={rowValue} onClick={() => handleLayoutTabRowSelect(rowValue)}>
                                                        {rowValue}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Rows on Mobile</span>
                                <div className="dropdown-container">
                                    <em onClick={toggleLayoutTabMobileRowsDropdown}>{selectedLayoutTabMobileRows}</em>
                                    {showLayoutTabMobileRowsDropdown && (
                                        <ul className="dropdown-list">
                                            {[...Array(8).keys()].map((i) => {
                                                const rowValue = i + 1;
                                                return (
                                                    <li key={rowValue} onClick={() => handleLayoutTabMobileRowSelect(rowValue)}>
                                                        {rowValue}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Item Spacing</span>
                                <em onClick={toggleLayoutTabSpacingDropdown}>{selectedLayoutTabSpacing}px</em>
                                {showLayoutTabSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {layoutTabSpacingValues.map((spacing) => (
                                            <li key={spacing} onClick={() => handleLayoutTabSpacingSelect(spacing)}>
                                                {spacing}px
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="box-header-row">
                                <span>Show Load More Button</span>
                                <div className="form-group">
                                    <input type="checkbox" id="show_load_more_toggle" className="chkbx-toggle" checked={showLayoutLoadMore} onChange={handlIsShowLoadMoreChange} />
                                    <label for="show_load_more_toggle"></label>
                                </div>
                            </div>
                            {/*<div className="box-header-row">
                                <span>Show Load More Button</span>
                                <div className="form-group">
                                    <input id="setting_open_link_in_new_tab_toggle1" className="chkbx-toggle" type="checkbox" value="1" />
                                    <label for="setting_open_link_in_new_tab_toggle1"></label>
                                </div>
                            </div>*/}
                        </div>

                    </div>
                </>
            )}

            {activeSettingElementsTab === "widget_title" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Widget Title</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Widget Title</span>
                                <div className="form-group">
                                    <input type="checkbox" id="header_show_widget_toggle" className="chkbx-toggle" checked={isWidgetTitle} onChange={handlIsWidgetTitleChange} />
                                    <label for="header_show_widget_toggle"></label>
                                </div>
                            </div>
                            {Number(testimonialTabData.layout_is_widget_title) === 1 && (
                            <>
                                <div className="box-header-row">
                                    <h6>Title</h6>
                                    <input type="text" value={widgetTitleName} placeholder="Title" onChange={handlWidgetTitleNameChange} className="title-text" />
                                </div>
                                <div className="box-header-row">
                                    <textarea id="editor" placeholder="Caption..." value={widgetCaptionName}  onChange={handlWidgetCaptionNameChange}></textarea>
                                </div>
                            </>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LayoutTab;